import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { FicheInterventionService } from 'src/app/_services/maintenance-service/fiche_intervention/fiche-intervention.service';
import { NotifService } from 'src/app/_services/notif.service';
import Swal from 'sweetalert2';
declare const $;
@Component({
  selector: 'app-fiche-intervention-all',
  templateUrl: './fiche-intervention-all.component.html',
  styleUrls: ['./fiche-intervention-all.component.scss']
})
export class FicheInterventionAllComponent implements OnInit {
  fiche_interventions: any;
  loading: boolean = true;
  @BlockUI() blockUI: NgBlockUI;

  //SweetAlert Text
  areYouSure = '';
  warning = ''
  yes = '';
  no = '';
  deleted = '';
  deletedMessage = '';
  cancelled = '';
  cancelledMessage = '';
  canCreate = false;
  canUpdate = false;
  canDelete = false;
  page = 1;
  data: any;

  constructor(
    private FicheInterventionService: FicheInterventionService,
    private authService: AuthService,
    private notifService: NotifService,
    private translate: TranslateService,
    private router: Router,
  ) {
    this.translate.get(
      ['SweetAlert.AreYouSure', 'SweetAlert.Warning', 'SweetAlert.Yes', 'SweetAlert.No', 'SweetAlert.Deleted',
        'SweetAlert.DeletedMessage', 'SweetAlert.Cancelled', 'SweetAlert.CancelledMessage'],
      { data: "Cette fiche d'intervention" })
      .subscribe(val => {
        this.areYouSure = val['SweetAlert.AreYouSure'];
        this.warning = val['SweetAlert.Warning'];
        this.yes = val['SweetAlert.Yes'];
        this.no = val['SweetAlert.No'];
        this.deleted = val['SweetAlert.Deleted'];
        this.deletedMessage = val['SweetAlert.DeletedMessage'];
        this.cancelled = val['SweetAlert.Cancelled'];
        this.cancelledMessage = val['SweetAlert.CancelledMessage'];
      });
  }

  ngOnInit(): void {
    console.log('junie')
    this.getFicheIntervention(this.page);
    const permissionSuffix = 'fiche_interventions';
    this.canCreate = this.authService.hasPermission(`${permissionSuffix}-create`);
    this.canUpdate = this.authService.hasPermission(`${permissionSuffix}-update`);
    this.canDelete = this.authService.hasPermission(`${permissionSuffix}-delete`);
  }

  getFicheIntervention(page) {
    this.loading = true;
    this.FicheInterventionService.gets(page).then(
      response => {
        this.fiche_interventions = response;
        console.log(this.fiche_interventions);
        $(function () {
          //$("#example1").DataTable().fnDestroy()
          $("#example1").DataTable({
            "responsive": true, "lengthChange": false, "autoWidth": false,
            "buttons": ["copy", "csv", "excel", "pdf", "print", "colvis"]
          }).buttons().container().appendTo('#example1_wrapper .col-md-6:eq(0)');
        });
      }
    ).catch(
      error => {
        this.notifService.danger(error.error.message)
      }
    ).finally(
      () => {
        this.loading = false;
      }
    );
  }


  getPage(url) {
    if (url) {
      this.FicheInterventionService.get(url).then((res) => {
        this.fiche_interventions = res;
        console.log(this.fiche_interventions);
      }).catch(
        error => {
          this.notifService.danger(error.error.message);
        }
      ).finally(
        () => {
          this.loading = false;
        }
      )
    }
  }


  detailsFicheIntervention(id) {
    this.router.navigate(['/fiche-intervention/detail/' + id])
  }

  editFicheIntervention(id) {
    console.log('Junie');
    this.router.navigate(['/fiche-intervention/update/' + id]);
  }
  deleteFicheIntervention(id) {
    Swal.fire({
      title: this.areYouSure,
      text: this.warning,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.yes,
      cancelButtonText: this.no
    }).then((result) => {
      if (result.value) {
        this.blockUI.start('Loading...');
        this.FicheInterventionService.delete(id).then(
          data => {
            this.blockUI.stop();
            Swal.fire(
              this.deleted,
              this.deletedMessage,
              'success'
            );
            this.getFicheIntervention(1);

          }
        ).catch(
          error => {
            console.log(error);
            this.blockUI.stop();
            this.translate.get('FicheIntervention.' + error.error.code)
              .subscribe(val => this.notifService.danger(val));
          }
        );

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.cancelled,
          this.cancelledMessage,
          'error'
        );
      }
    });
  }
  show(src){
    Swal.fire({
      imageUrl: src,
      imageHeight: 300,
      imageAlt: "Custom image",
      animation: false
  });
  }

}
